import { gql } from '@apollo/client';

export const PHONES_BY_COUNTRY = gql`
  query PhonesByCountry($params: PhonesByCountryParams!) {
    phonesByCountry(params: $params) {
      id
      phoneNumber
      contactTypes
    }
  }
`;
